<template>
    <div class="me-2">
        <div class="row ms-2">
            <slot />
            <div
                class="col-1 del ms-auto me-3 p-0"
                v-on:click="$emit('delete')" />
        </div>
    </div>
</template>

<script>
    export default {
        emits: ["delete"]
    };
</script>

<style lang="scss" scoped>
    // Copied from _orderable-item.vue
    $orderable-icon-img-size: 1rem;
    $orderable-icon-size: 2rem;

    %icon {
        background-size: $orderable-icon-img-size $orderable-icon-img-size;
        height: $orderable-icon-size;
        width: $orderable-icon-size;
        background-repeat: no-repeat;
        background-position: center;
        cursor: pointer;
    }
    %icon:hover {
        box-shadow: var(--bs-box-shadow-sm);
    }

    .del {
        @extend %icon;
        /*
            need to use the before  pseudo elemnt since we need to use filter to invert the icon
            and we dont want to interfere with the box-shadow
        */
        &::before {
            @extend %icon;
            content: "";
            display: block;
            background-image: url("Images/icons/trash.svg");
            filter: invert(100%);
        }
    }
</style>
